<script>
import Button from "primevue/button";
import AdaptersDialog from '../adapters/Dialog.vue';
import { UserEvents } from "../../constants/userEvents";
import UserApi from "../../api/UserApi";
import { Listeners } from "../../constants/listeners";

export default {
    name: "KsCreateFreeProjectDialog",
    components: {
        Button,
        AdaptersDialog,
    },
    data() {
        return {
            modal: {
                name: Listeners.POPUP_FREE_PROJECT,
                closeId: Listeners.POPUP_FREE_PROJECT_CLOSE,
            },
            hasCheckedProjects: false, // Новый флаг
        };
    },
    computed: {
        user() {
            return this.$store.getters.USER;
        },
        isMobile() {
            return window.innerWidth < 900;
        },
    },
    mounted() {
        this.checkProjects(); // Проверяем проекты только при монтировании
    },
    methods: {
        closeDialog() {
            UserApi.sendEvent(UserEvents.EVENT_DONT_CHECK_PROJECT_COUNT);
        },
        createProject() {
            window.location.href = "/projects?domain=";
        },
        checkProjects() {
            if (
                this.user.authState &&
                this.user.id &&
                !this.user.events.includes(UserEvents.EVENT_DONT_CHECK_PROJECT_COUNT) &&
                !this.hasCheckedProjects
            ) {
                this.hasCheckedProjects = true; // Устанавливаем флаг, чтобы больше не вызывалось
                UserApi.getProjectList().then((response) => {
                    if (response.length <= 1) {
                        this.$emitter.emit(this.modal.name);
                    }
                    UserApi.sendEvent(UserEvents.EVENT_DONT_CHECK_PROJECT_COUNT);
                });
            }
        },
    },
};
</script>

<template>
    <AdaptersDialog
        :listener-id="modal.name"
        :listener-close-id="modal.closeId"
        :callback-on-hide="closeDialog"
        :disableFooter="true"
        class="free-project-dialog"
        :dismissableMask="true"
    >
        <template #header><div></div></template>
        <template #content>
            <div class="width grid p-0">
                <div v-if="isMobile" class="col-12 lg:col-6 img p-0"></div>
                <div :class="['col-12 lg:col-6 p-0', {'text-center': isMobile}]">
                    <div class="dialog-header">{{ $t('lang.pages.common.firstReportModal.header') }}</div>
                    <p class="description p-0">
                        {{ $t('lang.pages.common.firstReportModal.description') }}
                    </p>
                    <Button
                        :label="$t('lang.pages.common.firstReportModal.btn')"
                        size="small"
                        icon="pi pi-plus"
                        @click="createProject"
                    />
                </div>
                <div v-if="!isMobile" class="col-12 lg:col-6 img p-0"></div>
            </div>
        </template>
    </AdaptersDialog>
</template>

<style scoped>
.dialog-header, .description {
    color: #36393C;
    font-family: Roboto;
    font-style: normal;
    line-height: 120%;
}
.dialog-header {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 32px;
}
.description {
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 64px;
}
.img {
    content: url('/i/icons/free-project-dialog.svg');
}
</style>
<style>
.free-project-dialog {
    max-width: 700px;
}
.free-project-dialog .p-dialog-content {
    margin-top: -50px
}
</style>
